import type { RouteObject } from 'react-router';

import { BASE, NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import SystemAdministrationPage from 'portal/src/pages/systemAdministration/SystemAdministrationPage';

import { generatePageWithTabsRoute } from './routeGenerator';
import { systemAdministrationRouteDefinitions } from './SystemAdministrationRouteDefinitions';

const SystemAdministrationRoutes: RouteObject = generatePageWithTabsRoute(
  'System Administration',
  BASE.SYSTEM_ADMINISTRATION,
  NESTED_ROUTES.SYSTEM_ADMINISTRATION.ORGANIZATIONS,
  systemAdministrationRouteDefinitions,
  SystemAdministrationPage,
);

export default SystemAdministrationRoutes;
